module.exports = __webpack_public_path__ + "img/00d54b0.jpg";